import { call, put, takeEvery, takeLatest, delay } from 'redux-saga/effects';

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN, START_TOKEN_WATCHER } from './actionTypes';
import { apiError, loginSuccess, logoutUserSuccess } from './actions';

//Include Both Helper File with needed methods
import { getFirebaseBackend } from '../../../helpers/firebase_helper';
import { postLoginData, postLogoutData, postValidateToken } from './helper';
import { changeLayout, changeLayoutMode, changeSidebarTheme, changeTopbarTheme } from 'store/actions';

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
	try {
		if (process.env.REACT_APP_DEFAULTAUTH === 'jwt') {
			const response = yield call(postLoginData, {
				email: user.email,
				password: user.password,
				webDeviceToken: user.webDeviceToken
			});
			localStorage.setItem('authUser', JSON.stringify(response));
			yield put(loginSuccess(response));
			if (response) {
				yield put({ type: START_TOKEN_WATCHER });
				let themeData = response?.themeData;
				if (themeData) {
					yield put(changeLayout(themeData?.layouts));
					yield put(changeLayoutMode(themeData?.layoutMode));
					yield put(changeTopbarTheme(themeData?.topBarTheme));
					yield put(changeSidebarTheme(themeData?.sidebarTheme));
				}
			}
			if (response) history('/dashboard');
		}
	} catch (error) {
		yield put(apiError(error?.response?.data));
	}
}

function* logoutUser({ payload: { history } }) {
	try {
		yield call(postLogoutData, { deviceType: 'web' });
		localStorage.removeItem('authUser');
		if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
			const response = yield call(fireBaseBackend.logout);
			yield put(logoutUserSuccess(response));
		}
		history('/login');
	} catch (error) {
		yield put(apiError(error));
	}
}

function* socialLogin({ payload: { type, history } }) {
	try {
		if (process.env.REACT_APP_DEFAULTAUTH === 'firebase') {
			const fireBaseBackend = getFirebaseBackend();
			const response = yield call(fireBaseBackend.socialLoginUser, type);
			if (response) {
				history('/dashboard');
			} else {
				history('/login');
			}
			localStorage.setItem('authUser', JSON.stringify(response));
			yield put(loginSuccess(response));
		}
		if (response) history('/dashboard');
	} catch (error) {
		console.log('error', error);
		yield put(apiError(error));
	}
}

function* tokenWatcherSaga() {
	const interval = 1 * 60 * 1000; // Check every 5 minutes

	while (true) {
		try {
			yield call(postValidateToken, {});
		} catch (error) {
			console.log('---watcher- error');
			if (error.response?.status === 401 || error.response?.status === 403) {
				// Dispatch an action to handle invalid tokens
				//yield put({ type: TOKEN_INVALID });
				break; // Stop the watcher if token is invalid
			}
		}

		yield delay(interval);
	}
}
function* authSaga() {
	yield takeEvery(LOGIN_USER, loginUser);
	yield takeLatest(SOCIAL_LOGIN, socialLogin);
	yield takeEvery(LOGOUT_USER, logoutUser);
	yield takeLatest(START_TOKEN_WATCHER, tokenWatcherSaga);
}

export default authSaga;
